import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';

class ConsumerDetails extends PureComponent {
  render() {
    const {consumer} = this.props;
    return (
      <div>
        <div data-rw="confirmation-page--consumer-name">{consumer.name}</div>
        <div data-rw="confirmation-page--consumer-email">{consumer.email}</div>
        <div data-rw="confirmation-page--consumer-phone">{consumer.phone}</div>
      </div>
    );
  }
}

ConsumerDetails.propTypes = {
  consumer: PropTypes.object.isRequired
};

export default ConsumerDetails;



// WEBPACK FOOTER //
// ./containers/ConfirmationPage/ConsumerDetails.js